"use client";
import { useQuery } from "@tanstack/react-query";
import { getRandomFiveBlogs } from "@/lib/actions/blogs/get/getRandomBlogs";

export const useGetRandomBlogs = (currentSlug: string) => {
  return useQuery({
    queryKey: ["random-blogs", currentSlug],
    queryFn: () => getRandomFiveBlogs(currentSlug),
  });
};